<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('uploadNegativeQuestionSet') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row style="margin-top: 1rem">
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                id="questionsetname-field-validationnegativedetail"
                :label="'Question Set Name'"
                :rules="[rules.required]"
                :disabled="actionEdit"
                v-model="searchNegativeName"
                variant="outlined"
                density="comfortable"
                color="primary"
                class="modern-text-field ml-6"
                clearable
                hide-details="auto"
                :readonly="!!nId"
              >
                <template v-slot:prepend-inner>
                  <v-icon 
                    :color="nId ? 'grey-darken-1' : 'primary'" 
                    size="small"
                  >
                    {{ nId ? 'mdi-database' : 'mdi-pencil-box-outline' }}
                  </v-icon>
                </template>
                
                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        color="grey-darken-1"
                        size="small"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('_InfoValidationNegariveName') }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-card
                v-if="uploadedFiles.length > 0"
                class="files-card"
                elevation="2"
                rounded="lg"
              >
                
                <v-virtual-scroll 
                  :items="uploadedFiles" 
                  :height="Math.min(uploadedFiles.length * 60, 120)" 
                  :item-height="60"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item class="file-item px-4 py-2">
                      <template v-slot:prepend>
                        <v-avatar size="36" color="success" class="mr-3">
                          <v-icon color="white" size="18">mdi-file-excel</v-icon>
                        </v-avatar>
                      </template>

                      <v-list-item-title class="text-subtitle-2 font-weight-medium">
                        {{ item.name }}
                      </v-list-item-title>
                      
                      <v-list-item-subtitle class="text-caption">
                        {{ formatFileSize(item.size) }}
                      </v-list-item-subtitle>

                      <template v-slot:append>
                        <v-btn 
                          @click.stop="removeFile(item.name)" 
                          icon="mdi-close"
                          size="small"
                          variant="text"
                          color="error"
                          class="ml-2"
                        />
                      </template>
                    </v-list-item>
                    <v-divider class="mx-4" v-if="uploadedFiles.indexOf(item) < uploadedFiles.length - 1" />
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              sm="12"
              md="5"
              class="d-flex justify-end align-center flex-wrap ga-3"
            >
              <!-- Template Button -->
              <v-btn
                id="template-validationnegativedetail"
                variant="outlined"
                color="info"
                size="small"
                prepend-icon="mdi-file-document-outline"
                class="template-btn"
                @click="download"
              >
                Template
              </v-btn>

              <!-- Upload Button (Proxy for DragDropFile) -->
              <v-btn
                v-if="permissions.add"
                id="upload-validationnegativedetail"
                variant="outlined"
                color="success"
                prepend-icon="mdi-upload"
                class="upload-btn"
                @click="triggerFileUpload"
              >
                Upload
              </v-btn>

              <!-- Hidden Drag Drop File Component -->
              <DragDropFile
                ref="dragDropComponent"
                :dialog="true"
                :DragDrop="false"
                :ShowListFile="false"
                :allowType="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
                @filesUploaded="processUpload($event)"
                class="upload-component"
                style="display: none;"
              />

              <!-- Process Button -->
              <v-btn
                v-if="permissions.add"
                id="button-process-validationnegativedetail"
                color="purple-darken-1"
                variant="flat"
                size="default"
                prepend-icon="mdi-cog"
                class="process-btn"
                @click="Save()"
                :disabled="!searchNegativeName || !request.entity"
              >
                PROCESS
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table-server
            class="modern-table"
            v-if="showTable == true"
            :items-per-page="itemsPerPage"
            :items-length="searchTotalTable"
            v-model:options="options"
            :items="dataTable"
            :headers="headers"
            :loading="loadingTable"
            loading-text="Loading..."
          >
            <template v-slot:item="{ item }">
              <tr>
                <td style="width: 81px; text-align: center">
                  {{ item.number }}
                </td>
                <td class="text-ellipsis">{{ item.question }}</td>
                <td style="text-align: center">
                  <v-btn
                    v-if="permissions.delete"
                    id="button-delete-validationnegativedetail"
                    variant="text"
                    density="comfortable"
                    @click="DeleteById(item.negativeID)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table-server>
          
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <div class="action-banner">
                <v-card class="banner-card" elevation="1" rounded="lg">
                  <v-card-text class="banner-content">
                    <v-spacer></v-spacer>
                    
                    <!-- Delete All Button -->
                    <v-btn
                      id="button-deleteall-validationnegativedetail"
                      v-if="permissions.delete && showTable == true"
                      variant="outlined"
                      color="error"
                      size="large"
                      prepend-icon="mdi-delete-sweep"
                      @click="DeleteByName(nId)"
                      class="delete-all-btn"
                    >
                      {{ $t('deleteAll') }}
                    </v-btn>
                    
                    <!-- Back Button -->
                    <v-btn
                      id="button-back-validationnegativedetail"
                      variant="flat"
                      color="orange"
                      size="large"
                      prepend-icon="mdi-arrow-left"
                      to="/ValidationNegative"
                      class="back-btn"
                    >
                      BACK
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-flex>
      </v-card>
    </v-container>
    
    <v-overlay :model-value="loadingTable || dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import DragDropFile from '@/components/DragDropFile.vue';
import ExcelJS from "exceljs";
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';

export default {
  name: 'ValidationNegativeDetail',
  inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
  components: { DragDropFile },
  props: ['id'],
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ValidationNegative');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('ValidationNegative'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('ValidationNegative'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('ValidationNegative'),
      }
    },
  },
  data: () => ({
    isInitialized: false,
    uploadDialog: false,
    checkbox1: false,
    actionEdit: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchNegativeName: null,
    nId: null,
    request: {
      name: null,
      entity: null,
    },
    options: {
      page: 1,
      sortBy: [],
      sortDesc: [],
      itemsPerPage: 10,
    },
    files: [],
    dataTable: [],
    uploadedFiles: [],
    headers: [],
    isSearch: false,
    isFirst: true,
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    showTable: false,
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    rules: {
      required: (value) => !!value || 'Required.',
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
  }),
  watch: {
    options: {
      handler() {
        if(!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    triggerFileUpload() {
      if (this.$refs.dragDropComponent) {
        // หากมี method เปิด dialog ใน DragDropFile
        if (typeof this.$refs.dragDropComponent.openFileDialog === 'function') {
          this.$refs.dragDropComponent.openFileDialog();
        } 
        // หรือหากมี input file ใน component
        else if (this.$refs.dragDropComponent.$el) {
          const fileInput = this.$refs.dragDropComponent.$el.querySelector('input[type="file"]');
          if (fileInput) {
            fileInput.click();
          }
        }
        // หรือใช้วิธีสร้าง input file เอง
        else {
          this.openFileSelector();
        }
      } else {
        // สำรองในกรณีที่ ref ไม่ทำงาน
        this.openFileSelector();
      }
    },
    Get() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.nId,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      self.$call.GetTableValidationNegativeDetail(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if(dataResponse.data == undefined || dataResponse.data == null)
            {
              self.dataTable = [];
              self.searchTotalTable = 0;
              self.totalTable = 0;
            } 
            else 
            {
              self.searchTotalTable = dataResponse.data.total;
              self.dataTable = dataResponse.data.data;
              if (dataResponse.data.data != undefined && dataResponse.data.data != null && dataResponse.data.data.length > 0) {
                self.searchNegativeName = dataResponse.data.data[0].name;
              }
              self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            }
          }
          else 
          {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
          self.showTable = true;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      let self = this;
      if (!self.searchNegativeName || !self.request.entity) {
        self.$swal.fire({
          icon: 'warning',
          title: "Please Fill All The Fields!",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      else
      {
        self.showTable = false;
        self.request.name = self.searchNegativeName;
        self.dialog = true;
        try {
          self.$call.UploadValidationNegative(
            self.request,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.actionEdit = true;
                self.isFirst = true;
                self.showTable = true;
                self.nId = dataResponse.data
                self.searchNegativeName = self.request.name;
                self.request.entity = null;
                self.uploadedFiles = [];
                if (self.$route.query.id !== String(self.nId)) {
                    window.location.href = `${self.$route.path}?id=${self.nId}`;
                }
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } catch (error) {
          this.LogTrace(error, 'DeleteGroup');
        }
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.request.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSV(text, this.files);
      };
    },
    ValidateCSV(csv, files) {
      // let temp = csv.replaceAll('\r', '');
      // let lines = temp.split('\n');
      // console.log(lines);
      // if (lines[0] != 'Questions') {
      //   this.request.entity = null;
      //   this.uploadedFiles = [];
      //   alert('Please Enter Correct Format!');
      // } else {
      //   const formDataDoc = new FormData();
      //   formDataDoc.append('entity', files[0]);
      //   this.uploadedFiles = files;
      //   this.request.entity = formDataDoc;
      // }
      const formDataDoc = new FormData();
      formDataDoc.append("entity", files[0]);
      this.uploadedFiles = files;
      this.request.entity = formDataDoc;
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit('filesUploaded', this.uploadedFiles);
    },
    DeleteById(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionQuestion'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteValidationNegativeDetail(
                id,
                (dataResponse) => {
                  self.dialog = false;
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    }).then(() => {
                      self.Get();
                    });
                  }
                  // self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    DeleteByName(name) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionAllQuestion'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteValidationNegative(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Clear();
                  }
                  self.dialog = false;
                  this.$router.push('/ValidationNegative');
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Clear() {
      let self = this;
      self.showTable = false;

      self.request.entity = null;
      self.request.name = null;

      self.searchNegativeName = null;
      self.dataTable = [];
      self.searchTotalTable = 0;
      self.totalTable = 0;

      this.$emit('back', true);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    async download(){
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทย"
        },
        {
          Questions: "จังหวัดที่อยู่ใต้สุดของประเทศไทย"
        },
        {
          Questions: "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทย"
        },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 30 }
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "upload_questions.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
  },
  mounted() {
    this.GetDate();
    this.headers = [
      {
        title: this.$t('no'),
        align: 'center',
        sortable: false,
      },
      { title: 'Question', align: 'center', sortable: true, value: 'Question' },
      { title: this.$t('delete'), align: 'center', sortable: false },
    ];
    if (this.$route.query.id) {
      this.searchNegativeName = this.$route.query.id;
      this.nId = this.$route.query.id;
      this.showTable = true;
      this.actionEdit = true;
    }
    this.Get();
    this.isInitialized = true;
  },
};
</script>
<style scoped>
/* =============================================================================
   MAIN LAYOUT STYLES
   ============================================================================= */
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.text-ellipsis {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =============================================================================
   MODERN TEXT FIELD STYLES
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
}

.modern-text-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-text-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Read-only state */
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-field--readonly:hover .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

/* Label styling */
.modern-text-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-text-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-text-field :deep(.v-field--readonly .v-label) {
  color: #6c757d !important;
}

/* Input text styling */
.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

/* Icon styling */
.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* =============================================================================
   FILES DISPLAY STYLES
   ============================================================================= */
.files-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  transition: all 0.2s ease;
}

.files-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.3);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08);
}

.files-card .v-card-title {
  background: rgba(var(--v-theme-surface-variant), 0.3);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.file-item {
  transition: background-color 0.2s ease;
}

.file-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.file-item .v-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

/* Custom scrollbar */
.v-virtual-scroll::-webkit-scrollbar {
  width: 4px;
}

.v-virtual-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.v-virtual-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 2px;
}

.v-virtual-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.3);
}

/* =============================================================================
   BUTTON STYLES
   ============================================================================= */
.template-btn {
  text-transform: none;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.template-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.3);
}
.upload-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(var(--v-theme-success), 0.2);
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-success), 0.3);
}


.process-btn {
  background: linear-gradient(135deg, #9747ff 0%, #7c3aed 100%);
  border-radius: 25px;
  min-width: 100px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(151, 71, 255, 0.3);
}

.process-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(151, 71, 255, 0.4);
}

.process-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.action-btn {
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
  color: rgb(var(--v-theme-error)) !important;
}

/* =============================================================================
   DATA TABLE STYLES
   ============================================================================= */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* =============================================================================
   ACTION BANNER STYLES
   ============================================================================= */
.action-banner {
  margin: 24px 0 16px 0;
  padding: 0 8px;
}

.banner-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08) !important;
  transition: all 0.3s ease;
}

.banner-card:hover {
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08) !important;
}

.banner-content {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 16px !important;
  padding: 16px 24px !important;
  min-height: 60px;
}

.delete-all-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 140px !important;
  border-width: 2px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.delete-all-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.08) !important;
  border-color: rgb(var(--v-theme-error)) !important;
  transform: translateY(-2px) !important;
}

.delete-all-btn:active {
  transform: translateY(0) !important;
}

.back-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%) !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  color: white !important;
}

.back-btn:hover {
  background: linear-gradient(135deg, #f57c00 0%, #e65100 100%) !important;
  transform: translateY(-2px) !important;
}

.back-btn .v-icon {
  color: white !important;
}

/* Enhanced hover states for banner buttons */
.delete-all-btn .v-icon,
.back-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.delete-all-btn:hover .v-icon {
  transform: scale(1.1) rotate(-5deg) !important;
}

.back-btn:hover .v-icon {
  transform: scale(1.1) translateX(-2px) !important;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 960px) {
  .d-flex.justify-end {
    justify-content: center !important;
  }
  
  .process-btn {
    min-width: 120px;
  }
}

@media (max-width: 768px) {
  /* Action Banner */
  .action-banner {
    margin: 16px 0 12px 0;
    padding: 0 4px;
  }
  
  .banner-content {
    padding: 12px 16px !important;
    gap: 12px !important;
    flex-direction: column-reverse !important;
    align-items: stretch !important;
  }
  
  .delete-all-btn,
  .back-btn {
    width: 100% !important;
    min-width: auto !important;
    justify-content: center !important;
  }
  
  .delete-all-btn {
    order: 2;
  }
  
  .back-btn {
    order: 1;
  }
}

@media (max-width: 600px) {
  .ga-3 {
    gap: 0.5rem !important;
  }
  
  .process-btn {
    font-size: 0.875rem;
    min-width: 100px;
  }

  .banner-content {
    gap: 8px !important;
  }
  
  .delete-all-btn,
  .back-btn {
    font-size: 0.875rem !important;
    padding: 12px 16px !important;
  }
  
  .back-btn {
    letter-spacing: 0.5px !important;
  }
  .process-btn,
  .upload-btn {
    font-size: 0.875rem;
    min-width: 100px;
  }
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead) {
  position: sticky;
  top: 0;
  z-index: 2;
}

.modern-table :deep(.v-table__wrapper thead th) {
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
  height: 8px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
